import { create } from 'zustand';

// ナビゲーションの状態を管理するインターフェース
interface NavigationState {
  isExpanded: boolean; // ナビゲーションが展開されているかどうか
  toggleNavigation: () => void; // ナビゲーションの展開/折りたたみを切り替えるメソッド
  setExpanded: (expanded: boolean) => void; // ナビゲーションの展開状態を設定するメソッド
}

/**
 * ナビゲーションの状態を管理するカスタムフック
 */
export const useNavigationState = create<NavigationState>((set) => ({
  // #region 初期状態の設定
  isExpanded: true, // 初期状態は展開されている
  // #endregion

  // #region メソッドの定義
  toggleNavigation: () => set((state) => ({ isExpanded: !state.isExpanded })), // ナビゲーションの展開状態を切り替える
  setExpanded: (expanded) => set({ isExpanded: expanded }), // 指定された状態にナビゲーションを設定する
  // #endregion
}));